<template>
  <a-form-item
    :validate-status="error ? 'error' : ''"
    :help="error"
    class="simple-input-form-item"
  >
    <div class="simple-input">
      <label class="input-label">{{ label }}</label>
      <div class="input-wrapper">
        <a-input
          :type="inputType"
          :value="value"
          @input="handleInput"
          :placeholder="placeholder"
          :class="{
            'ant-input-error': error,
            'with-icon': (type === 'password' && !error) || error,
          }"
          size="large"
        />

        <span
          v-if="type === 'password' && !error"
          class="eye-icon material-icons"
          @click="togglePasswordVisibility"
        >
          {{ showPassword ? "visibility_off" : "visibility" }}
        </span>

        <span v-if="error" class="error-icon material-icons">error_outline</span>
      </div>
    </div>
  </a-form-item>
</template>

<script>
export default {
  name: "StandardSimpleInput",
  props: {
    label: String,
    value: String,
    type: {
      type: String,
      default: "text",
    },
    placeholder: String,
    error: String,
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    inputType() {
      return this.type === "password"
        ? this.showPassword
          ? "text"
          : "password"
        : this.type;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    handleInput(event) {
      this.$emit("input", event.target.value);
      if (this.error) {
        this.$emit("clear-error");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.simple-input-form-item {
  margin-bottom: 1.4rem;

  :deep(.ant-form-item-control) {
    line-height: 1;
  }

  :deep(.ant-form-explain),
  :deep(.ant-form-item-explain-error) {
    text-align: right !important;
    margin-top: 4px;
    color: #d32f2f !important;
    font-size: 12px;
  }
}

.simple-input {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .input-label {
    font-weight: 600;
    font-size: 14px;
    color: #757575;
    font-family: "DM Sans", sans-serif !important;
    margin-bottom: 4px;
  }
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  &:deep(.ant-input) {
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid #e0e0e0 !important;
    background: #ffffff;
    font-family: "DM Sans", sans-serif;
    width: 100%;
    height: 42px;
    transition: all 0.2s ease;

    &:focus,
    &:focus-visible,
    &.ant-input-focused {
      outline: none !important;
      border-color: #f39f21 !important;
      box-shadow: 0 0 0 2px rgba(243, 159, 33, 0.2) !important;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgba(243, 159, 33, 0.2) !important;
    }

    &::placeholder {
      color: #bdbdbd;
      padding: 0 !important;
      margin: 0 !important;
      text-indent: 0 !important;
    }

    &.with-icon {
      padding-right: 40px;
    }

    &.ant-input-error {
      border-color: #d32f2f;
      background-color: #fff5f5;

      &:focus {
        border-color: #d32f2f !important;
        box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.2) !important;
      }
    }
  }
}

.error-icon {
  position: absolute;
  right: 12px;
  color: #d32f2f;
  font-size: 20px;
  pointer-events: none;
  z-index: 2;
}

.eye-icon {
  position: absolute;
  right: 12px;
  cursor: pointer;
  user-select: none;
  color: #757575;
  font-size: 20px;
  z-index: 2;

  &:hover {
    color: #424242;
  }
}

:deep(.ant-form-item) {
  margin-bottom: 0;
}

:deep(.ant-form-item-label) {
  padding: 0 !important;
  line-height: 1;
}

:deep(.ant-form-item-control) {
  line-height: 1;
}
::placeholder{
  padding: 0 !important;
}


</style>
